export default __webpack_public_path__ + "static/media/intro4.aa551064.mp3";